import { getLocale } from '@/services/IdentityService';
import en from '@/translations/en';
import pt from '@/translations/pt';
import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import _ from 'underscore';
import { LocaleState, LocaleTypes } from './types';

const INITIAL_STATE: LocaleState = {
    data: getLocale() === 'pt' ? pt : en,
    availableContentLanguages: [],
    currentContentLanguage: '',
    currentContentSubtitle: '',
    loading: false,
    hasError: false,
};

const reducer: Reducer<LocaleState> = (state: LocaleState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case LocaleTypes.SET:
            return { ...state, data: { ...action.payload } };
        case LocaleTypes.SET_CURRENT_CONTENT_LANGUAGE:
            return { ...state, currentContentLanguage: action.payload };
        case LocaleTypes.SET_CURRENT_CONTENT_SUBTITLE:
            return { ...state, currentContentSubtitle: action.payload };
        case LocaleTypes.CLEAR_CURRENT_CONTENT_LANGUAGE:
            return { ...state, currentContentLanguage: '' };
        case LocaleTypes.GET_CONTENT_LOCALE_REQUEST:
        case LocaleTypes.SET_CONTENT_LOCALE_REQUEST:
            return { ...state, loading: true, hasError: false };
        case LocaleTypes.GET_CONTENT_LOCALE_SUCCESS:
        case LocaleTypes.SET_CONTENT_LOCALE_SUCCESS:
            return {
                ...state,
                loading: false,
                hasError: false,
                availableContentLanguages: _.isEqual(state.availableContentLanguages, action.payload)
                    ? state.availableContentLanguages
                    : action.payload,
            };
        case LocaleTypes.GET_CONTENT_LOCALE_FAILURE:
        case LocaleTypes.SET_CONTENT_LOCALE_FAILURE:
            return { ...state, loading: false, hasError: true };
        default:
            return state;
    }
};

export default reducer;
